import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/settings/")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: `/${encodeURIComponent(params.org)}/settings/general` });
  },
});
